import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Array of all main images
  const sliderImages = [
    '/images/gallery/double-bed/main.jpg',
    '/images/gallery/four-person/main.jpg',
    '/images/gallery/group-hall/main.jpg',
    '/images/gallery/amenities/main.jpg',
    '/images/about/main.jpg'
  ];

  // Auto-slide every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [sliderImages.length]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-slider">
        {sliderImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${process.env.PUBLIC_URL}${image})`
            }}
          />
        ))}
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">Welcome to Ruma Palace</h1>
          <p className="hero-subtitle">Your Comfortable Stay in the Heart of Ujjain</p>
        
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => scrollToSection('rooms')}>
              View Rooms
            </button>
            <button className="btn btn-outline" onClick={() => scrollToSection('about')}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="hero-scroll">
        <span>Scroll Down</span>
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;

